// extracted by mini-css-extract-plugin
export default {"control":"LanguagePicker_control__XWGbk","label":"LanguagePicker_label__HFKYy","icon":"LanguagePicker_icon__VVu+u"};